var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"spinner__wrapper"},[_c('div',{staticClass:"spinner__A"}),_c('div',{staticClass:"spinner__B"}),_c('div',{staticClass:"spinner__C"})])])}]

export { render, staticRenderFns }